import {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import { StockReport } from '../../modules/reports/StockReport'; // Import from the new location
import { useIntl } from 'react-intl'; // Import useIntl for translations

const StockReportPage: FC = () => {
  const intl = useIntl(); // Initialize intl
  return (
    <>
      {/* Use translation ID for the title */}
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.PRODUCTS.STOCK_REPORT'})}</PageTitle>
      <StockReport /> {/* Use the renamed wrapper component */}
    </>
  )
}

export default StockReportPage
